/**
 * en-GB messages added by Phase 2 task S20 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s20EnGB = {
    'feedback.question.default': 'How was your visit to {site}?',
    'feedback.report.noHost': 'No host',
    'error.feedback_locked': 'This answer can no longer be changed.',
    'email.feedback.request.subject': 'How was your visit to {{site.name}}?',
    'email.feedback.request.body': '<p>Hello {{person.first_name}},</p><p>Thank you for visiting {{site.name}}. How was your visit? Tap a number from 1 (poor) to 5 (excellent):</p><p>{{feedback.rating_links}}</p>',
    'email.feedback.unsubscribe': 'Unsubscribe from feedback emails',
};
//# sourceMappingURL=s20.js.map